import React, { useState, useEffect } from 'react';
import { Center, FlatList, Box, useTheme, Spinner } from 'native-base';
import { Platform } from 'react-native';
import Topic from './Topic';
import { useMessageBusState } from '../../../context/messagebus';
import Banner from '../common/reusables/Banner';
import { DEVICE_HEIGHT } from '../../../components/Constants';
import ForumHeader from './ForumHeader';
const Topics = ({
  topics,
  loadContents,
  updateTopicPost,
  updateTopicReplies,
  navigation,
  loadMoreTopics,
  updateForceReloadTopics,
  platform,
  discourseKey,
  showUserProfile,
  getUniqueList,
  closeReplyBanner,
  refreshTopic,
  trackForum,
  startNewTopicButtonRef,
  setNextPage,
  hasMoreTopics,
  setHasMoreTopics,
  showFetchSpinner,
  reply
}) => {
  const {
    colors
  } = useTheme();
  const messageBusState = useMessageBusState();
  const [topicIdListForReplies, setTopicIdListForReplies] = useState([]);
  useEffect(() => {
    setTopicIdListForReplies(getUniqueList(messageBusState.replies));
  }, [messageBusState.replies]);
  const refreshReplyBanner = id => {
    refreshTopic(id);
    updateTopicReplies();
  };
  const renderItem = ({
    item: topic,
    index
  }) => {
    if (index === 0) {
      return topic;
    }
    return /*#__PURE__*/React.createElement(Box, {
      pt: 4,
      mt: 3,
      borderRadius: {
        base: 0,
        lg: 8
      },
      borderColor: colors.topic.box.border,
      borderLeftWidth: {
        base: 0,
        lg: 1
      },
      borderRightWidth: {
        base: 0,
        lg: 1
      },
      borderTopWidth: 1,
      borderBottomWidth: 1
    }, /*#__PURE__*/React.createElement(Banner, {
      type: 'reply',
      refresh: refreshReplyBanner,
      close: closeReplyBanner,
      topicId: topic.id,
      topicIdList: topicIdListForReplies
    }), /*#__PURE__*/React.createElement(Topic, {
      updateTopicReplies: updateTopicReplies,
      topic: topic,
      updateTopicPost: updateTopicPost,
      key: topic.id,
      navigation: navigation,
      loadContents: loadContents,
      showUserProfile: showUserProfile,
      trackForum: trackForum,
      reply: reply,
      platformUser: platform,
      forceReloadToggle: updateForceReloadTopics,
      forumKey: discourseKey
    }));
  };
  topics = [/*#__PURE__*/React.createElement(ForumHeader, {
    navigation: navigation,
    startNewTopicButtonRef: startNewTopicButtonRef,
    setPage: setNextPage,
    setHasMoreTopics: setHasMoreTopics,
    updateTopicPost: updateTopicPost,
    updateTopicReplies: updateTopicReplies,
    showUserProfile: showUserProfile,
    trackForum: trackForum,
    colors: colors
  }), ...topics];
  const ListEmptyComponent = () => showFetchSpinner && /*#__PURE__*/React.createElement(Box, {
    h: 20,
    justifyContent: 'center'
  }, /*#__PURE__*/React.createElement(Spinner, {
    mt: 5
  }));
  return /*#__PURE__*/React.createElement(Center, {
    width: '100%',
    height: Platform.OS === 'web' ? DEVICE_HEIGHT : '100%'
  }, /*#__PURE__*/React.createElement(FlatList, {
    data: topics,
    renderItem: renderItem,
    keyExtractor: topic => topic.id,
    onEndReached: loadMoreTopics,
    onEndReachedThreshold: 0.3,
    ListEmptyComponent: ListEmptyComponent,
    ListFooterComponent: ListEmptyComponent,
    width: '100%',
    mb: !hasMoreTopics && {
      base: 600,
      xs: 200
    }
  }));
};
export default Topics;
//# sourceMappingURL=Topics.js.map